"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowSelectionId = exports.STATE_EVENT_HANDLER_KEYS = void 0;
exports.STATE_EVENT_HANDLER_KEYS = [
    'onInit',
    'onToggleSortBy',
    'onResetPage',
    'onSetFilter',
    'onSetGlobalFilter',
    'onGotoPage',
    'onToggleRowSelected',
    'onToggleAllPageRowsSelected',
    'onToggleHideColumn',
    'onToggleRowExpanded'
];
exports.RowSelectionId = 'table__row-selection';
// #endregion
//# sourceMappingURL=typings.js.map